import { Form, Formik } from "formik";
import { FormControl } from "@app/components/form-control";
import Input from "@app/components/input";
import { useEffect, useState } from "react";
import Button from "@app/components/button";
import GoogleConsoleService from "@app/services/http/google-console.service";
import { DeleteAccount } from "@app/types";
import { addToast } from "@app/components/toast/toast.service";

function DeleteAccountPage() {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [reason, setReason] = useState("");

  const handleSubmit = async (values: any) => {
    setUsername(values.username.toString().trim());
    setEmail(values.email.toString().trim());
    setReason(values.reason.toString().trim());
  };

  useEffect(() => {
    if (username && email && reason) {
      const deleteAccount: DeleteAccount = {
        username,
        email,
        reason,
      };

      GoogleConsoleService.deleteAccount(deleteAccount).then(() => {
        addToast({ text: "Vui lòng kiểm tra email của bạn để xác thực!" });
      });
    } else {
      alert("Vui lòng nhập thông tin!");
    }
  }, [username, email, reason]);

  return (
    <div>
      <p className="w-[70%] text-justify mx-auto mt-5">
        Bookas JSC Bookas.vn - Yêu cầu xoá tài khoản Bạn cần điền thông tin: Tên
        đăng nhập và email của liên quan đến tài khoản, Lý do muốn xoá tài
        khoản. Sau khi gởi biểu mẫu, bạn sẽ nhận được một email xác thực. Vui
        lòng bấm vào link để hoàn tất yêu cầu xoá tài khoản Một khi yêu cầu đã
        hoàn tất, tất cả thông tin tài khoản, lịch sử hoạt động, các gói thuê
        bao đã đăng ký sẽ bị xoá vĩnh viễn ra khỏi hệ thống lưu trữ của Bookas
      </p>
      <div className="w-[30%] mx-auto">
        <Formik
          initialValues={{ username, email, reason }}
          onSubmit={handleSubmit}
        >
          <Form>
            <div className="flex flex-col gap-8">
              <div className="">
                <div className="mt-2 flex font-bold">Username</div>
                <FormControl name="username">
                  <Input
                    className="!h-7 font-[Arial] text-[12.61px] border-none"
                    inputClassName="border-none font-[Arial]"
                    placeholder="Username"
                  />
                </FormControl>
              </div>
              <div className="">
                <div className="mt-2 flex font-bold">Email</div>
                <FormControl name="email">
                  <Input
                    className="!h-7 font-[Arial] text-[12.61px] border-none"
                    inputClassName="border-none font-[Arial]"
                    placeholder="Email"
                  />
                </FormControl>
              </div>
              <div className="">
                <div className="mt-2 flex font-bold">Reason</div>
                <FormControl name="reason">
                  <Input
                    className="!h-7 font-[Arial] text-[12.61px] border-none"
                    inputClassName="border-none font-[Arial]"
                    placeholder="Reason"
                  />
                </FormControl>
              </div>

              <Button label="Delete" type="submit" className="mt-2" />
            </div>
          </Form>
        </Formik>
      </div>
    </div>
  );
}

export default DeleteAccountPage;
